exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.close-icon-img[data-v-6ef5d8b5]{width:0.75rem;height:0.75rem\n}\n", "", {"version":3,"sources":["/build/src/components/base/ftCloseIcon.vue"],"names":[],"mappings":";AAAA,iCAAgB,cAAc,cAAc;CAAC","file":"ftCloseIcon.vue","sourcesContent":[".close-icon-img{width:0.75rem;height:0.75rem}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6ef5d8b5","scoped":true,"hasInlineConfig":false}!./build/loader/img-loader.js?{"replace":"~_style/common/img"}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/base/ftCloseIcon.vue
// module id = Kfcu
// module chunks = 37